define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/store/Memory",
	"dojo/store/Observable",
	"dgrid/extensions/DijitRegistry",
	"dgrid/OnDemandGrid",
	"dgrid/editor",
	"csi",
	"csi/_base/underscore",
	"csi/locale",
	"csi/sessionConstants",
	"csi/state/rootStore",
	"csi/page/SearchManager",
	"csi/widget/CheckBox",
	"csi/xml",
	"./_RoleBasedGrid"
], function(declare, lang, Memory, Observable, GridDijitRegistry, OnDemandGrid, editor,
	csi, _, locale, sessionConstants, {sessionStore}, SearchManager, CheckBox, xml, _RoleBasedGrid) {

	/**
	 * create and set store based on plugin parameters
	 * @param {Node} rolePrefs
	 * @param {Boolean} bDisabled
	 */
	const _getSearchOptionStore = function(rolePrefs, bDisabled) {
		let hiddenTypes = csi.hashArray(sessionStore.sitePreferences.HiddenSearchTypes, null, Boolean);
		let disabledTypes = {};

		if (rolePrefs) {
			disabledTypes = hiddenTypes;
			hiddenTypes = csi.hashArray(rolePrefs.HiddenSearchTypes, null, Boolean);
		}

		const items = SearchManager.getTypeItems();

		_.each(items, function(item) {
			item.disabled = bDisabled || !!disabledTypes[item.id];
			item.visible = !item.disabled && !hiddenTypes[item.id];
		});

		return Observable(new Memory({data: items}));
	};

	return declare(_RoleBasedGrid, {
		ATTRIBUTE: "HiddenSearchTypes",

		_buildView: function() {
			// summary: create and set store based on plugin parameters
			const store = _getSearchOptionStore(sessionStore.getRolePreferences(this._urlRole), !sessionConstants.configEditor);

			if (this._grid) {
				this._grid.set("store", store);
			} else {
				this._grid = new (declare([OnDemandGrid, GridDijitRegistry]))({
					"class": "csi-grid-tableView csi-grid-views search-options-grid",
					showFooter: true,
					store: store,
					columns: [
						{
							className: "left",
							field: "name",
							label: locale.resource("Class"),
							sortable: true
						},
						editor({
							autoSave: false,
							canEdit: function(obj) {
								this.editorArgs.disabled = obj.disabled;
								return true;
							},
							className: "csi-grid-checkbox",
							editor: CheckBox,
							editorArgs: {},
							field: "visible",
							label: locale.resource("Visible"),
							sortable: true
						})
					]
				}, this.contentNode);

				this._grid.on("dgrid-datachange", lang.hitch(this, this._onDataChange));
			}

			this.inherited(arguments);
		},

		_onDataChange: function(evt) {
			// summary: publish change to server
			var url = this._getPreferencesUrl();
			var b = evt.value;
			var cell = evt.cell;
			var attrId = this.ATTRIBUTE;

			this.writeOperations((writer) => {
				writer.changeNode(url).changeAttribute(attrId, xml.ATTR_STRINGLIST, [cell.row.id], !b, b);
			});
		}
	});
});